/* eslint-disable camelcase */
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { css, StyleSheet } from 'aphrodite';
import { Checkbox, Grid } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';

import { ApiHelper } from '../../../common/helpers/ApiHelper';
import { AppConfig } from '../../../AppConfig';
import { AppStyles, AppTheme } from '../../../styles/AppTheme';
import { BaseEntityPageSlixta } from '../../../components/BaseEntityPageSlixta';
import { Helper } from '../../../common/helpers/Helper';
import { SubEntityCard } from '../../../common/components/SubEntity/SubEntityCard';
import { UiHelper } from '../../../common/helpers/UiHelper';
import { Controller } from '../../../common/Controller';
import { SubEntityList } from '../../../common/components/SubEntity/SubEntityList';
import TableCard from '../../../common/components/tables/TableCard';
import { AppHelper } from '../../../helpers/AppHelper';
import { AppButton } from '../../../common/components/AppButton';
import { TabTableCard } from '../../../common/components/tables/TabTableCard';
import { CRMHelper } from '../../../helpers/CRMHelper';
import { ButtonList } from '../../../common/components/ButtonList';
import { CrmContact } from './CrmContact';
import { StaffHelper } from '../../../common/helpers/StaffHelper';

const CREATABLE_TYPES = ['NOTE']
const EDITABLE_TYPES = ['NOTE']

export class CrmAccount extends BaseEntityPageSlixta {

  constructor(props) {
    super(props);
    this.ms = AppConfig.CDP_MS.ENDPOINT
    this.pageKey = 'crm-account'
    this.pageTitle = Helper.getString('crm-account')
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.subOrgId = Controller.get().userMgr().getSubOrgId(this.orgId)
    this.teamsEnabled = AppHelper.isTeamsEnabled(this.orgId)
    this.crmAccountId = this.props.match.params.id
    this.staffUserId = Controller.get().getUserId()
    this.attribsGroupId = 'settingscrmcontactattrs' + this.orgId
    this.aggregationTermsLimit = 100
    this.restrictViewCrmFilters = { 'tags!': 'INTERNAL' }
    if (AppHelper.isRestrictViewToAssignedAccounts(this.orgId)) {
      this.restrictViewCrmFilters.assignee = this.staffUserId
    }
    this.isMobileView = Helper.isMobileView()
    this.pageDialogMode = this.props.pageDialogMode || false
    this.isLogoForMobileHidden = this.props.isLogoForMobileHidden || false
    this.isHeaderTitleHidden = this.props.isHeaderTitleHidden || false
    this.hideHeaderbar = this.props.hideHeaderbar || false

    this.apiData = {
      orgId: this.orgId,
    }
    this.staffUsers = []
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute() },
      { title: Helper.getString('crm-accounts'), to: `${this.baseRoute()}/crm-accounts` },
      { title: this.crmAccountId },
    ]
    this.toFetch = [
      { key: 'interactions', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['interactions'], queryParams: { entityTypeEntityId: `CRMACCOUNT-${this.crmAccountId}`, pb: 'fieldDef', limit: 100, orgId: this.orgId, _includeWorkflows: 'YES', _staffSubOrgId: this.subOrgId } },
      { key: 'crmaccount', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['crmaccounts', this.crmAccountId], queryParams: { orgId: this.orgId, pb: 'fieldDef', includeCustomFields: 'true' } },
      { key: 'crmaccounts', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['crmaccounts'], queryParams: { orgId: this.orgId, pb: 'fieldDef', includeCustomFields: 'true', limit: 1, ...this.restrictViewCrmFilters, _datetimezone: Helper.getLocalTimezone(), _dateinterval: '1d', _aggTermsLimit: this.aggregationTermsLimit } },
      { key: 'crmcontacts', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['crmcontacts'], queryParams: { orgId: this.orgId, accounts: this.crmAccountId, limit: 100, pb: 'fieldDef'  } },
      { key: 'crmcontactattrs', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['items', `${this.attribsGroupId}-all`], queryParams: { orgId: this.orgId, groupId: this.attribsGroupId } },
      { key: 'orgusers', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['miscs', 'get-org-users2'], queryParams: {orgId: this.orgId, parentOrgId: this.orgId } },
    ]
    if (this.teamsEnabled && !this.subOrgId) {
      this.toFetch.push({ key: 'suborgs', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['miscs', 'get-sub-orgs'], queryParams: {orgId: this.orgId, parentOrgId: this.orgId } })
    }
    this.interactionsTableCellWidths = {
      Index: Styles.cellWidthSmall,
      Date: Styles.cellWidthNormal,
      Info: Styles.cellWidthNormal,
      Interaction: this.isMobileView ? Styles.fullWidthWide : Styles.cellWidthWide,
      Summary: Styles.fullWidthWide,
    }

    this.contactsTableCellWidths = {
      Index: Styles.cellWidthSmall,
      Info: Styles.cellWidthWide,
      Info2: Styles.cellWidthNormal
    }
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Date: (current) => { return Helper.formatTimestamp(current.createdTs) },
      Info: (current) => {
        const creator = current.creatorName || Helper.formatName(this.staffUsers.find(u => u.id === current.creatorId || u.userId === current.creatorId))
        return <div>
          {creator && <span className={css(Styles.line2)}>Creator: {creator}</span>}
        </div>
      },
      Interaction: (current) => {
        let summary = ''
        let interactionName = current.iType
        switch (current.iType) {
        case 'NOTE': summary = Helper.renderHtmlText(current.noteRichText); break;
        case 'UPDATE': summary = UiHelper.getUpdateDiffSummary(current, this.crmAccountFieldDef); break
        default:
        {
          if (current.payload && current.payload._workflow) {
            const workflow = current.payload._workflow
            const workflowData = current.payload._workflowData || {}
            const workflowResponse = current.payload._workflowResponse || []
            const workflowFieldDef = workflow.fieldDef
            interactionName = workflow.title
            const parts = []
            Object.keys(workflowData).forEach(k => {
              const field = UiHelper.withLinkedOptions(Helper.getField(workflowFieldDef, k), this.crmAccountFieldDef)
              if (!field || !workflowData[k]) { return }
              if (field.type === 'rich_text') {
                const noteVal = typeof workflowData[k] === 'string' ? workflowData[k] : JSON.stringify(workflowData[k])
                parts.push(`<div>${Helper.escapeHtml(field.label)}: ${Helper.renderHtmlOrPlainText(noteVal)}</div>`)
              } else {
                const readableVal = UiHelper.getReadableVal(k, field, workflowData)
                parts.push(`<p>${field.label}: ${readableVal}</p>`)
              }
            })
            summary = parts.join('')
          }
          break;
        }
        }

        return (
          <div>
            <span className={css(Styles.line1)}>{interactionName}</span>
            <br/>
            <span className={css(Styles.line2, Styles.summaryContainer)} id={'id_' + current.__index} dangerouslySetInnerHTML={{ __html: summary }}></span>
          </div>
        )
      },
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    const isAccountEditSummaryEnabled = AppHelper.isSettingEnabled(this.orgId, 'CRM_ACCOUNT_EDIT_SUMMARY')
    const isAccountEnrichEnabled = AppHelper.isSettingEnabled(this.orgId, 'CRM_ACCOUNT_ENRICH')
    this.headerActions = [
      ...(isAccountEditSummaryEnabled ? [{
        label: 'Edit',
        tooltip: 'Edit',
        icon: 'edit',
        type: 'icon-label',
        onClick: () => this.openModalForEditSummary(),
      }] : []),
      ...((this.subOrgId || this.isMobileView || !isAccountEnrichEnabled) ? [] : [{
        label: 'Enrich',
        tooltip: 'Enrich',
        icon: 'dynamic_form',
        type: 'icon-label',
        onClick: () => UiHelper.openModalForEnrichAccount.call(this, { id: this.crmAccountId }),
      }]),
      {
        label: 'Interaction',
        tooltip: 'Add Interaction',
        icon: 'add',
        type: 'icon-label',
        onClick: () => this.openModalForAddStep1(),
      },
      {
        label: 'Contacts',
        tooltip: 'View Contacts',
        icon: 'person',
        type: 'icon-label',
        onClick: () => this.openContactsForAccount(),
      },
      {
        label: 'Refresh',
        tooltip: 'Refresh',
        icon: 'refresh',
        type: 'icon-label',
        onClick: () => this.fetchItems(),
      }
    ]
    this.uploadLocation = `${this.orgId}/__FILENAME__`
    this.uploadMs = AppConfig.CDP_MS.ENDPOINT

    this.state.chartTabsData =  {
      interactionsTable: [
        {
          title: Helper.getString('info'),
          key: 'summary',
        },
        {
          title: 'Interactions',
          key: 'interactions',
        },
        {
          title: 'Contacts',
          key: 'contacts',
        }
      ]
    }
    this.state.selectedTabData = {
      interactionsTable: 0,
    }
    this.state.showUpdateInteractions = false
  }

  componentDidMount() {
    this.updateDialogHeader()
    this.fetchItems()
  }

  onFetchSuccess(results, options) {
    const { fetchNext } = options || {}
    if (!fetchNext) {
      this.interactions = this.getResult(results, 'interactions').items
      this.fieldDef = this.formDefinition = this.getResult(results, 'interactions').fieldDef
      this.workflows = CRMHelper.extractWorkflows(this.getResult(results, 'interactions'))
      this.crmAccountFieldDef = this.getResult(results, 'crmaccount').fieldDef
      this.crmAccountsListResult = this.getResult(results, 'crmaccounts')
      this.crmAccountsStats = CRMHelper.getCrmAccountFormEnrichmentStats(this.crmAccountsListResult)
      this.staffUsers = this.getResult(results, 'orgusers').items
      this.crmAccount = this.getResult(results, 'crmaccount')
      this.crmContactsResult = this.getResult(results, 'crmcontacts')
      this.crmContacts = this.getResult(results, 'crmcontacts').items
      this.crmContactAttrs = this.getResult(results, 'crmcontactattrs')
      this.subOrgs = this.getResult(results, 'suborgs') ? this.getResult(results, 'suborgs').items : []
      const showTenantNameInHeader = AppHelper.isSettingEnabled(this.orgId, 'TENANT_NAME_IN_HEADER')
      if (this.props.pageTitle) { this.pageTitle = this.props.pageTitle }
      else if (showTenantNameInHeader) {
        this.pageTitle = UiHelper.getOrgTitle() ||  this.pageTitle
      }
      this.currentStaffUser = this.staffUsers.find(u => u.userId === this.staffUserId) || {}
      if (this.crmAccountsListResult && this.crmAccountsListResult.fieldDef) {
        CRMHelper.copySelectOptionsFromBaseFieldDef(this.crmAccountFieldDef, this.crmAccountsListResult.fieldDef)
        if (this.crmAccountsListResult.fieldDef.options) {
          this.crmAccountFieldDef.options = {
            ...(this.crmAccountFieldDef.options || {}),
            ...this.crmAccountsListResult.fieldDef.options,
          }
        }
      }
      Helper.loadAttrOptions(this.crmAccountFieldDef, this.crmContactAttrs, 'tags')
      CRMHelper.enrichCrmAccountFormFieldDefOptions(this.crmAccountFieldDef, {
        stats: this.crmAccountsStats,
        crmContactAttrs: this.crmContactAttrs,
      })
      UiHelper.populateOptions(this.crmAccountFieldDef, {items: StaffHelper.uniqueStaffByUserId(this.staffUsers)}, 'assignee')
      UiHelper.populateOptions(this.fieldDef, {items: this.staffUsers}, 'creatorId')
      //this.fieldDef.steps[0].fields.find(f => f.key === 'creatorId').options.push({key: this.orgIdUserId, label: Helper.formatName(this.crmUser)})
      UiHelper.populateOptions(this.fieldDef, {items: StaffHelper.uniqueStaffByUserId(this.staffUsers)}, 'noteMentions')
      if(this.crmAccountFieldDef) {
        UiHelper.filterFieldForMainOrgOptions(this.crmAccountFieldDef, 'assignee', this.subOrgs, this.staffUsers, this.orgId)
      }
      if(this.fieldDef) {
        UiHelper.filterFieldForMainOrgOptions(this.fieldDef, 'noteMentions', this.subOrgs, this.staffUsers, this.orgId)
      }

      this.breadCrumbs = [
        { title: Helper.getString('home'), to: this.baseRoute() },
        { title: Helper.getString('crm-accounts'), to: `${this.baseRoute()}/crm-accounts` },
        { title: this.crmAccount.title || this.crmAccount.accountKey || '?' },
      ]
    }
    this.handleNextpage(results[0])
    const mergedItems = fetchNext ? this.state.items.concat(results[0].items) : results[0].items
    this.setState({
      items: mergedItems,
      staffUsers: this.staffUsers,
      currentStaffUser: this.currentStaffUser,
      crmAccount: this.crmAccount,
    })

    let allowedImageFormats = null
    if(this.fieldDef) {
      const imageField = Helper.getField(this.fieldDef, 'image')
      if(imageField) {
        allowedImageFormats = Helper.getAllowedFormatsFromImageField(imageField)
      }
    }
    this.enableAssetPicker({allowedFormats: allowedImageFormats})
  }

  getSelectedTabKey(tableType = 'interactionsTable') {
    const tabs = this.state && this.state.chartTabsData && this.state.chartTabsData[tableType]
    const selectedIndex = this.state && this.state.selectedTabData && this.state.selectedTabData[tableType]
    const tab = tabs && (selectedIndex || selectedIndex === 0) ? tabs[selectedIndex] : null
    return tab && tab.key
  }

  getCellWidth() {
    if (this.getSelectedTabKey() === 'contacts') {
      return this.contactsTableCellWidths
    }
    return this.interactionsTableCellWidths
  }

  renderMediaContent(current) {
    if(current.mediaLink) {
      if(current.msgType === 'image') {
        return(<div
          className={css(Styles.mediaBubble)}>
          <img
            src={current.mediaLink}
            alt={current.mediaLink || 'Preview'}
            className={css(Styles.mediaPreview)}
          />
        </div>)
      }
    }
  }

  updateDialogHeader() {
    if (this.props.setDialogHeader) {
      this.props.setDialogHeader( <div className={css(Styles.dialogHeadercontainer)}>
        {this.headerActions && this.headerActions.map((actionItem, index) => {
          if (actionItem.type === 'icon') {
            return (
              <div className={css(Styles.link)} key={index}>
                <Tooltip title={actionItem.tooltip} arrow classes={{ popper: css(Styles.tooltip) }}>
                  <div className={css(Styles.dialogHeaderImageContainer)} onClick={actionItem.onClick}>
                    <i className='material-icons-outlined' style={{ fontSize: 20, margin: 14, color: '#222222' }} >{actionItem.icon}</i>
                  </div>
                </Tooltip>
              </div>
            )
          } else if (actionItem.type === 'icon-label') {
            return (
              <div className={css(Styles.link)} key={index}>
                <Tooltip title={actionItem.tooltip} arrow classes={{ popper: css(Styles.tooltip) }}>
                  <div className={css(Styles.dialogHeaderIconLabelContainer)} onClick={actionItem.onClick}>
                    {typeof actionItem.icon === 'string' && <div><i className='material-icons-outlined' style={{ fontSize: 20 }} >{actionItem.icon}</i></div>}
                    {typeof actionItem.icon !== 'string' && actionItem.icon}
                    <p className={css(Styles.dialogHeaderIconLabelText)}>{actionItem.label}</p>
                  </div>
                </Tooltip>
              </div>
            )
          } else if (actionItem.type === 'icon-label-link') {
            return (
              <div className={css(Styles.link)} key={index}>
                <a className={css(Styles.iconLabelLink)} href={actionItem.link} target='_blank'>
                  <Tooltip title={actionItem.tooltip} arrow classes={{ popper: css(Styles.tooltip) }}>
                    <div className={css(Styles.dialogHeaderIconLabelContainer)}>
                      {typeof actionItem.icon === 'string' && <div><i className='material-icons-outlined' style={{ fontSize: 20 }} >{actionItem.icon}</i></div>}
                      {typeof actionItem.icon !== 'string' && actionItem.icon}
                      <p className={css(Styles.dialogHeaderIconLabelText)}>{actionItem.label}</p>
                    </div>
                  </Tooltip>
                </a>
              </div>
            )
          } else {
            return (
              <AppButton
                key={index}
                buttonStyle={Styles.dialogHeaderButton}
                onClick={actionItem.onClick}
                buttonText={actionItem.label}
                icon={actionItem.icon || 'add'}
              />
            )
          }
        })}
      </div>);
    }
  }

  contactsTableRowActons(key, cell, header) {
    const userId = Array.isArray(cell) && cell[1]
    const actions = []
    if(userId) {
      actions.push(
        <Link to={this.baseRoute() + '/crm-contacts/' + userId} key={userId}>
          <Tooltip title='Detail Page' placement='top-start'>
            <span className={css(AppStyles.entityTableLinkIcon)}>
              <i className='material-icons-outlined'>arrow_forward_ios</i>
            </span>
          </Tooltip>
        </Link>
      )
    }

    return actions
  }

  getInteractionSummary(current) {
    let summary = ''
    let imageLink = null
    let interactionName = current.iType
    switch (current.iType) {
    case 'NOTE':
      summary = Helper.renderHtmlText(current.noteRichText);
      imageLink = current.noteImageLink
      break;
    case 'UPDATE':
      summary = UiHelper.getUpdateDiffSummary(current, this.crmAccountFieldDef);
      break
    default:
    {
      if (current.payload && current.payload._workflow) {
        const workflow = current.payload._workflow
        const workflowData = current.payload._workflowData || {}
        const workflowResponse = current.payload._workflowResponse || []
        const workflowFieldDef = workflow.fieldDef
        interactionName = workflow.title
        const parts = []
        Object.keys(workflowData).forEach(k => {
          const field = UiHelper.withLinkedOptions(Helper.getField(workflowFieldDef, k), this.crmAccountFieldDef)
          if (field && (workflowData[k] === 0 || workflowData[k])) {
            const value = workflowData[k];
            if (field.type === 'rich_text') {
              const noteVal = typeof value === 'string' ? value : JSON.stringify(value)
              parts.push(`<div>${Helper.escapeHtml(field.label)}: ${Helper.renderHtmlOrPlainText(noteVal)}</div>`)
            } else {
              const readableVal = (value === 0) ? '0' : UiHelper.getReadableVal(k, field, workflowData);
              parts.push(`<p>${field.label}: ${readableVal}</p>`)
            }
          }
        })
        summary = parts.join('')
      }
      break;
    }

    }

    return {summary,imageLink,interactionName}
  }

  getCreator = (current) => {
    let creator = ''
    if(current) {
      creator = current.creatorName || Helper.formatName(this.staffUsers.find(u => u.id === current.creatorId || u.userId === current.creatorId))
    }
    return creator
  }

  renderInteractionMobile(current) {
    const creator = this.getCreator(current)
    const {summary,imageLink,interactionName} = this.getInteractionSummary(current)
    return(<div className={css(Styles.chatRow)}>
      <div className={css([Styles.chatBubble, Styles.chatBubbleInteraction])}>
        <div className={css(Styles.chatBubbleMsgPart)}>
          <span className={css(Styles.chatBubbleTitle)}>{interactionName}</span>
          {imageLink && (this.renderMediaContent({msgType: 'image',mediaLink: imageLink}))}
          {(<div className={css(Styles.messageText)} dangerouslySetInnerHTML={{ __html: summary }}/>)}
        </div>
        <div className={css(Styles.interactionsMobileStatusContainer)}>
          <div className={css(Styles.waStatusText)}>{creator}</div>
          {current.createdTs && <span className={css(Styles.waStatusText)}>{Helper.formatTimestamp(current.createdTs)}</span>}
        </div>
      </div>
    </div>)
  }

    handleTabChange = (tab, chartType) => {
      this.setState({
        selectedTabData: {
          ...this.state.selectedTabData,
          [chartType]: tab
        }
      })
    }

    renderInteractionInfo(current) {
      const creator = this.getCreator(current)
      return <div>
        {creator && <span className={css(Styles.line2)}>Creator: {creator}</span>}
      </div>
    }

    renderInteraction(current) {
      const {summary,imageLink,interactionName} = this.getInteractionSummary(current)

      return (
        <div>
          <span className={css(Styles.line1)}>{interactionName}</span>
          <br/>
          {imageLink && (this.renderMediaContent({msgType: 'image',mediaLink: imageLink}))}
          <span className={css(Styles.line2, Styles.summaryContainer)} id={'id_' + current.__index} dangerouslySetInnerHTML={{ __html: summary }}></span>
        </div>
      )
    }

    getContactInfoCell(current) {
      let previewFields = null
      const contactPreviewTemplate = AppHelper.getSetting(this.orgId, 'CRM_CONTACT_PREVIEW_TEMPLATE')
      if(contactPreviewTemplate) {
        previewFields = contactPreviewTemplate.split('|')
          .map(part =>part.split(',')
            .map(item =>item.trim())
            .filter(item => item !== '')
          ).filter(arr => arr.length > 0)
      }
      const fieldDef = this.crmContactsResult && this.crmContactsResult.fieldDef && JSON.parse(JSON.stringify(this.crmContactsResult.fieldDef))
      const displayTs = current.createdTs
      return (
        <div>
          <Fragment>
            {previewFields &&  Array.isArray(previewFields) && previewFields.flat().length > 0 && CRMHelper.getPreviewFromFields(current,fieldDef,previewFields,displayTs)}
            {(!previewFields || previewFields.length === 0) && !this.isMobileView && CRMHelper.getContactInfoCellSpan(current)}
            {(!previewFields || previewFields.length === 0) && this.isMobileView && CRMHelper.getContactInfoCellSpanMobile(current, displayTs)}
            {!this.isMobileView && (!previewFields || previewFields.length === 0) && <br />}
          </Fragment>
          {!this.isMobileView && <Fragment>
            <span className={css(Styles.line3)}>{Helper.formatTimestamp(displayTs)}</span>
            <br />
          </Fragment>}
        </div>
      )
    }

    getContactInfo2Cell(current) {
      const subOrg = this.subOrgs.find(s => s.id === current.subOrgId)
      return (
        <div>
          {current.state &&
                <Fragment>
                  <span className={current.state === 'CUSTOMER' ? css(Styles.line2, Styles.statusBadge, Styles.statusBadgeCustomer) : css(Styles.line2, Styles.statusBadge)}>{UiHelper.renameCRMContactLeadStatus(this.orgId,current.state)}</span>
                </Fragment>
          }
          {!this.isMobileView && current.source &&
                <Fragment>
                  <span className={css(Styles.line2)}>Source: {current.source}</span>
                  <br />
                </Fragment>
          }
          {!this.isMobileView && this.teamsEnabled && subOrg &&
                <Fragment>
                  <span className={css(Styles.line2)}>Team: {subOrg.title}</span>
                  <br />
                </Fragment>
          }
          {!this.isMobileView && Array.isArray(current.tags) && current.tags.length > 0 &&
                <Fragment>
                  <span className={css(Styles.line2)}>Tags: {current.tags.join(', ')}</span>
                  <br />
                </Fragment>
          }
        </div>
      )
    }

    getTableData(tableKey) {
      let tableData = null

      if(tableKey === 'interactions') {
        let interactions = []

        if(this.isMobileView) {
          if(this.state && this.state.items) {
            let rowIndex = 0
            interactions = this.state.items.map((item,index)=>{
              if(!this.state.showUpdateInteractions && item.iType === 'UPDATE') {
                return null
              }
              rowIndex = rowIndex + 1
              const interaction = this.renderInteractionMobile(item)
              return([interaction, item])
            }).filter(a => !!a)
          }

          tableData = {
            headers: ['Interaction', 'Data'],
            rows: interactions,
            textColumnIndices: [0],
            noWrapColumnIndices: [0],
            hiddenColumnIndices: [1]
          }
        } else {
          if(this.state && this.state.items) {
            let rowIndex = 0
            interactions = this.state.items.map((item,index)=>{
              if(!this.state.showUpdateInteractions && item.iType === 'UPDATE') {
                return null
              }
              rowIndex = rowIndex + 1
              const date = Helper.formatTimestamp(item.createdTs)
              const info = this.renderInteractionInfo(item)
              const interaction = this.renderInteraction(item)
              return([rowIndex, date, info, interaction, item])
            }).filter(a => !!a)
          }

          tableData = {
            headers: ['Index', 'Date', 'Info', 'Interaction', 'Data'],
            rows: interactions,
            textColumnIndices: [0,1,2,3],
            noWrapColumnIndices: [2,3],
            hiddenColumnIndices: [4]
          }
        }
      } else if(tableKey === 'contacts') {
        const contacts = this.crmContacts.map((crmContact,index)=>{
          return([index + 1, this.getContactInfoCell(crmContact), this.getContactInfo2Cell(crmContact), crmContact])
        })

        tableData = {
          headers: ['Index', 'Info', 'Info2', 'Data'],
          rows: contacts,
          textColumnIndices: [0,1,2],
          hiddenColumnIndices: this.isMobileView ? [0,3] : [3],
          hiddenColumnHeaders: ['Info2']
        }
      } else if(tableKey === 'summary') {
        tableData = {
          headers: ['Summary'],
          rows: [[this.renderSummaryCard()]],
          textColumnIndices: [0],
          noWrapColumnIndices: [0],
        }
      }
      return tableData
    }

    getSummaryFieldDef() {
      let crmAccountFieldDef = JSON.parse(JSON.stringify(this.crmAccountFieldDef))
      const crmAccountSummaryFieldsCdpSettings = AppHelper.getSetting(this.orgId, 'CRM_ACCOUNT_SUMMARY_FIELDS')
      if(crmAccountSummaryFieldsCdpSettings) {
        const crmAccountSummaryFields = crmAccountSummaryFieldsCdpSettings.split(',').map(item => item.trim()).filter(Boolean)
        if(crmAccountSummaryFields && crmAccountSummaryFields.length > 0) {
          crmAccountFieldDef = Helper.getFilteredFieldDef(crmAccountFieldDef, crmAccountSummaryFields)
        }
      }
      return crmAccountFieldDef
    }

    renderSummaryCard() {
      const crmAccountCp = this.state.crmAccount && JSON.parse(JSON.stringify(this.state.crmAccount))
      return (
        <SubEntityCard
          renderFieldsRowwise={true}
          title={'Summary'}
          formDefinition={CRMHelper.markTextFieldsAsHyperlinks(this.getSummaryFieldDef(), crmAccountCp)}
          item={crmAccountCp || {}}
          hideTitle={true}
          noEdit={true}
          embedded={true}
        />
      )
    }

    renderShowUpdateInteractions() {
      if (this.isMobileView || this.getSelectedTabKey() !== 'interactions') {
        return null
      }
      return (
        <div className={css(Styles.showUpdateInteractions)}>
          <Checkbox
            onChange={(e) => {
              this.setState({ showUpdateInteractions: e.target.checked })
            }}
            name={'showUpdateInteractions'} color='primary'
            checked={this.state.showUpdateInteractions} />
          {Helper.getString('showAccountUpdates')}
        </div>
      )
    }

    interactionsTableRowActions(key, cell, header) {
      const selectedTabKey = this.getSelectedTabKey()
      if(selectedTabKey === 'interactions') {
        const item = Array.isArray(cell) && cell[4]
        if(item) {
          return this.onInteractionsTableActions(item)
        }
      } else if(selectedTabKey === 'contacts') {
        const item = Array.isArray(cell) && cell[3]
        if(item) {
          return this.onContactsTableActions(item)
        }
      }
    }

    renderBelowTable() {
      let tableTitle = ''
      let tableKey = null
      if(this.state && this.state.chartTabsData && this.state.chartTabsData.interactionsTable && this.state.selectedTabData && (this.state.selectedTabData.interactionsTable || this.state.selectedTabData.interactionsTable === 0)) {
        const chartTabData =  this.state.chartTabsData.interactionsTable[this.state.selectedTabData.interactionsTable]
        tableKey = chartTabData && chartTabData.key
        tableTitle = (chartTabData && chartTabData.title) ? chartTabData.title : ''
      }
      const tableData = this.getTableData(tableKey)
      const cellWidths = this.getCellWidth()
      const selectedTabKey = this.getSelectedTabKey()
      return(
        <div className={css(Styles.containerNarrow)}>
          <Grid container {...(this.isMobileView ? {} : {spacing: 4})}>
            <Grid item xs={12} sm={12}>
              <TabTableCard
                tableType={'interactionsTable'}
                tabsData={this.state.chartTabsData}
                tableTitle={tableTitle}
                tableData={tableData}
                selectedTabData={this.state.selectedTabData}
                cellWidths={cellWidths}
                disableTooltip={true}
                showMoreInTable={true}
                standardTabView={true}
                showTabSeparator={true}
                hideRowSeparators={selectedTabKey === 'summary' || (this.isMobileView && selectedTabKey === 'interactions')}
                hideTableHeader={this.isMobileView || selectedTabKey === 'summary'}
                lockTabMinHeight={true}
                handleTabChange={this.handleTabChange}
                tableRowActions={this.interactionsTableRowActions.bind(this)}
                renderTabActions={!this.isMobileView ? this.renderShowUpdateInteractions.bind(this) : null}
              />
            </Grid>
          </Grid>
        </div>
      )
    }


    openContactsForAccount() {
      window.open(`/admin/orgs/${this.orgId}/crm-contacts?accounts=${this.crmAccountId}` , this.isMobileView ? '_self' : '_blank')
    }

    openModalForAddStep1() {
      this.apiData = {
        orgId: this.orgId,
        _staffSubOrgId: this.subOrgId,
        entityType: 'CRMACCOUNT',
        entityId: this.crmAccountId,
        entityName: this.crmAccount.title,
        isAddStep1: true,
      }
      this.formDefinition = JSON.parse(JSON.stringify(this.fieldDef))
      this.formDefinition.formType = 'add'
      this.formDefinition.ctaButtonText = 'Next'
      this.formDefinition.disableAlwaysFormFields = this.formDefinition.disableAlwaysFormFields || []
      this.formDefinition.steps[0].fields = this.formDefinition.steps[0].fields.filter(f => ['iType', 'creatorId'].includes(f.key))
      const iTypeField = this.formDefinition.steps[0].fields.find(f => f.key === 'iType')
      iTypeField.options = iTypeField.options.filter(o => CREATABLE_TYPES.includes(o.key) )
      if(AppHelper.isSettingEnabled(this.orgId, 'CRM_ACCOUNT_EDIT_INTERACTION')) {
        iTypeField.options.unshift({key:'EDIT_ACCOUNT', label:'EDIT ACCOUNT'})
        iTypeField.defaultValue = 'EDIT_ACCOUNT'
      }
      Object.values(this.workflows || {}).forEach(workflow => {
        if (iTypeField.options.every(ct => ct.key !== workflow.key)) {
          iTypeField.options.push({key: workflow.key, label: workflow.title})
        }
      })

      const creatorIdField = this.formDefinition.steps[0].fields.find(f => f.key === 'creatorId')
      if (creatorIdField) { creatorIdField.defaultValue = `${this.subOrgId || this.orgId}-${this.staffUserId}` }
      this.formDefinition.disableAlwaysFormFields = ['creatorId']

      if(this.isMobileView) {
        const customPageDialogProps = {
          pageTitle: 'Interactions',
          items: iTypeField.options,
          CustomPageDialogComp: ButtonList,
          onButtonClick: (action)=> {
            const options = {
              formData: {
                iType: action.key,
                creatorId: creatorIdField.defaultValue,
                ...this.apiData,
              }
            }
            this.setState({
              customPageDialogOpen: false
            },()=>{
              this.customSubmitForAddStep1(options)
            })
          }
        }
        this.openModalForCustomPageDialog(customPageDialogProps)
      } else {
        this.setState({
          modalOpen: true
        });
      }
    }

    openModalForAdd(fieldDef, apiData = {}, iType) {
      this.apiData = {
        orgId: this.orgId,
        _staffSubOrgId: this.subOrgId,
        entityType: 'CRMACCOUNT',
        entityId: this.crmAccountId,
        entityName: this.crmAccount.title,
        ...apiData,
      }
      const fieldDefCp = JSON.parse(JSON.stringify(fieldDef))
      fieldDefCp.steps[0].fields = fieldDefCp.steps[0].fields.filter(f => {
        if (f.condition && f.condition.key === 'iType' && Array.isArray(f.condition.values) && !f.condition.values.includes(iType)) {
          return false
        }
        return true
      })

      fieldDefCp.disableAlwaysFormFields = ['iType', 'creatorId']
      if (iType in (this.workflows || {})) {
        fieldDefCp.steps[0].fields.push(...this.workflows[iType].fieldDef.steps[0].fields)
        if (Array.isArray(this.workflows[iType].fieldDef.disableAlwaysFormFields)) {
          fieldDefCp.disableAlwaysFormFields.push(...this.workflows[iType].fieldDef.disableAlwaysFormFields)
        }

        if(this.workflows[iType]._hasWa) {
          fieldDefCp.description = Helper.getString('sendWhatsAppMessage')
          fieldDefCp.customStyles = {
            modalDescriptionStyles: Styles.customModalDescriptionStyles,
          };
        }
      }
      super.openModalForAdd(fieldDefCp, false)
    }

    onAdd() {
      this.setState({
        apiMethod: 'POST',
        apiEndPoint: ApiHelper.makeUrlPath2({ ms: this.ms, paths: ['interactions'], queryParams: {orgId: this.orgId} }),
      });
    }

    openModalForEditSummary = () => {
      const current = this.state.crmAccount && JSON.parse(JSON.stringify(this.state.crmAccount))
      if (!current) { return }
      CRMHelper.enrichCrmAccountFormFieldDefOptions(this.crmAccountFieldDef, {
        stats: this.crmAccountsStats,
        crmContactAttrs: this.crmContactAttrs,
      })
      const fieldDef = CRMHelper.buildCrmAccountEditFieldDef(this.getSummaryFieldDef(), current, {
        isMobileView: this.isMobileView,
        stats: this.crmAccountsStats,
        crmContactAttrs: this.crmContactAttrs,
        optionsSourceFieldDef: this.crmAccountFieldDef,
      })
      this.openModalForEdit(current, fieldDef)
    }

    openModalForEdit(current, formDefinition) {
      this.apiData = {
        orgId: this.orgId,
        _staffSubOrgId: this.subOrgId,
        entityType: 'CRMACCOUNT',
        entityId: this.crmAccountId,
      }
      if (formDefinition) {
        this.formDefinition = formDefinition
        this.formDefinition.formType = 'edit'
        Helper.populateFormDefinitionValues(this.formDefinition, current)
        CRMHelper.normalizeAssigneeFieldValues(this.formDefinition, ['assignee'])
        this.setState({
          apiMethod: 'POST',
          apiEndPoint: ApiHelper.makeUrlPath2({
            ms: AppConfig.CDP_MS.ENDPOINT,
            paths: ['miscs', 'update-crm-account'],
            queryParams: { id: current.id, orgId: this.orgId }
          }),
        });
        this.setState({ modalOpen: true })
      } else {
        const fieldDefCp = JSON.parse(JSON.stringify(this.fieldDef))
        super.openModalForEdit(current, {
          steps: fieldDefCp.steps,
          disableAlwaysFormFields: ['iType', 'creatorId'],
        });
      }
    }

    onEdit(current) {
      CRMHelper.normalizeAssigneeFieldValues(this.formDefinition, ['noteMentions'])
      this.setState({
        apiMethod: 'PUT',
        apiEndPoint: ApiHelper.makeUrlPath2({ ms: this.ms, paths: ['interactions', current.id], queryParams: {orgId: this.orgId} }),
      });
    }

    openModalForDelete(current, fieldDef) {
      this.apiData = {
        orgId: this.orgId,
        _staffSubOrgId: this.subOrgId,
        entityType: 'CRMACCOUNT',
        entityId: this.crmAccountId,
      }
      super.openModalForDelete(current, fieldDef)
    }

    onDelete(current) {
      this.setState({
        apiMethod: 'DELETE',
        apiEndPoint: ApiHelper.makeUrlPath2({ ms: this.ms, paths: ['interactions', current.id], queryParams: {orgId: this.orgId} }),
      });
    }

  onInteractionsTableActions = (current) => {
    const actions = []
    if (EDITABLE_TYPES.includes(current.iType)) {
      actions.push(UiHelper.buttonEdit(this, current))
      actions.push(UiHelper.buttonDelete(this, current))
    }
    return actions
  }

  openInteractionsDialog(current) {
    if(current) {
      const customPageDialogProps = {
        pageTitle: Helper.formatName(current),
        CustomPageDialogComp: CrmContact,
        match: {params: {orgId: this.orgId, userId: current.userId}},
        hideAccountsButton: true,
        hideBreadCrumbs: true,
        isLogoForMobileHidden: true,
        isHeaderTitleHidden: true,
        hideHeaderbar: true,
        fullHeightPageDialog: true,
        fullWidthPageDialog: true,
        backTitle: Helper.getString('backToAccount')
      }
      this.openModalForCustomPageDialog(customPageDialogProps)
    }
  }

  onContactsTableActions = (current) => {
    const actions = []
    if (AppHelper.isEntityInPlaceDrillDown(this.orgId)) {
      actions.push(
        <Tooltip title={'Interactions'} placement='top-start' key={current.id + 'inPlaceDD'}>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined' onClick={(e) => {
              e.stopPropagation()
              this.openInteractionsDialog(current)
            }}>contact_page</i>
          </span>
        </Tooltip>
      )
    }
    return actions
  }

  customSubmitForAddStep1(options) {
    let fieldDef = JSON.parse(JSON.stringify(this.fieldDef))
    const { formData } = options

    delete formData.isAddStep1

    const apiData = {}
    fieldDef.steps[0].fields.find(f => f.key === 'iType').defaultValue = formData.iType
    fieldDef.steps[0].fields.find(f => f.key === 'creatorId').defaultValue = formData.creatorId
    if(formData.iType === 'EDIT_ACCOUNT') {
      fieldDef = JSON.parse(JSON.stringify(this.crmAccountFieldDef))
      const editAccountInteractionsFieldsCdpSettings = AppHelper.getSetting(this.orgId, 'CRM_ACCOUNT_EDIT_INTERACTION_FIELDS')
      const editAccountInteractionsFields = editAccountInteractionsFieldsCdpSettings && editAccountInteractionsFieldsCdpSettings.split(',').map(item => item.trim()).filter(Boolean)
      if(editAccountInteractionsFields && editAccountInteractionsFields.length > 0) {
        fieldDef = Helper.getFilteredFieldDef(fieldDef, editAccountInteractionsFields)
      }
      const crmAccountCp = this.state.crmAccount && JSON.parse(JSON.stringify(this.state.crmAccount))
      CRMHelper.enrichCrmAccountFormFieldDefOptions(this.crmAccountFieldDef, {
        stats: this.crmAccountsStats,
        crmContactAttrs: this.crmContactAttrs,
      })
      const editFieldDef = CRMHelper.buildCrmAccountEditFieldDef(fieldDef, crmAccountCp, {
        isMobileView: this.isMobileView,
        stats: this.crmAccountsStats,
        crmContactAttrs: this.crmContactAttrs,
        optionsSourceFieldDef: this.crmAccountFieldDef,
      })
      this.setState({ fetchState: ApiHelper.State.READY, modalOpen: false }, () => {
        apiData.isAddStep2 = true
        this.openModalForEdit(crmAccountCp, editFieldDef)
      })
    } else {
      this.setState({ fetchState: ApiHelper.State.READY, modalOpen: false }, () => {
        apiData.isAddStep2 = true
        this.openModalForAdd(fieldDef, apiData, formData.iType)
      })
    }
  }

  onCompleteAction(options) {
    this.setState({ modalOpen: false, dialogApiData: options && options.apiInvokeData })
    this.fetchItems()
  }

  async customSubmit(options) {
    const { formType, formData, caller } = options
    if (formData.isAddStep1) { return this.customSubmitForAddStep1(options) }
    if (formData._isAccountEnrich) { return UiHelper.customSubmitForEnrichAccount.call(this, options) }

    const apiData = JSON.parse(JSON.stringify(formData))
    if(apiData.isAddStep2) {
      delete apiData.isAddStep2

      if (apiData.iType in this.workflows) {
        apiData._isWorkflow = 'YES'
        apiData.payload = { _workflowData: {} }
        this.workflows[apiData.iType].fieldDef.steps[0].fields.forEach(f => {
          apiData.payload._workflowData[f.key] = apiData[f.key]
          delete apiData[f.key]
        })
      }
    }
    return caller.submit.call(caller, apiData, true);
  }
}

const Styles = StyleSheet.create({
  line1: {
    fontSize: 16,
  },
  line2: {
    fontSize: 12,
    color: 'grey'
  },
  statusBadge: {
    backgroundColor: AppTheme.primaryBg,
    // color: 'white',
    padding: 5,
    borderRadius: 10,
    wordBreak: 'keep-all',
    display: 'block',
    textAlign: 'center',
    maxWidth: 100,
  },
  statusBadgeCustomer: {
    backgroundColor: '#3BDE86',
    color: '#222222'
  },
  summaryContainer: {
    wordBreak: 'break-word'
  },
  cellWidthSmall: {
    width: '10%',
    padding: '8px 5px',
  },
  cellWidthNormal: {
    width: '20%',
    padding: '8px 5px',
  },
  cellWidthWide: {
    width: '50%',
    padding: '8px 5px',
  },
  fullWidthWide: {
    width: '100%',
    padding: '8px 5px',
    '@media (max-width: 767px)': {
      fontSize: 10,
      padding: '5px 2px',
    },
  },
  containerNarrow: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 10,
    maxWidth: AppTheme.viewPort,
    paddingBottom: 30,
    width: '100%',
    '@media (max-width: 767px)': {//TODO: next?
      //width: window.innerWidth - 20 //TODO: fix it, in product screen whitespace nowrap creating issue
    },
  },
  infoCellContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  infoCell2Container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '50%'
  },
  spanValue: {
    fontSize: 16
  },
  line3: {
    fontSize: 12,
    color: 'grey'
  },
  InfoCellWidth: {
    width: '60%'
  },
  dialogHeadercontainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 25
  },
  dialogHeaderImageContainer: {
    width: 48,
    height: 48,
    backgroundColor: AppTheme.secondaryBg,
    borderRadius: '50%',
    display: 'flex',
    cursor: 'pointer',
  },
  dialogHeaderIconLabelContainer: {
    width: 48,
    color: AppTheme.primaryColor,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  dialogHeaderIconLabelText: {
    margin: 0,
    fontSize: 12,
    textTransform: 'capitalize',
  },
  dialogHeaderButton: {
    minWidth: 160,
    marginLeft: 10
  },
  showUpdateInteractions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    whiteSpace: 'nowrap',
  },
  chatRow: {
    display: 'flex',
    marginBottom: 8
  },
  chatBubble: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: 5,
    maxWidth: '80%',
    minWidth: '30%',
    padding: '8px 10px',
    borderRadius: 8,
    position: 'relative',
    backgroundColor: '#f0f2f5',
    boxShadow: '0 1px 1px rgba(0,0,0,0.1)'
  },
  chatBubbleInteraction: {
    width: '100%',
    maxWidth: '100%',
  },
  chatBubbleMsgPart: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    maxWidth: '100%',
    gap: 5
  },
  chatBubbleTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#777777',
  },
  messageText: {
    fontSize: 14,
    lineHeight: '18px',
    color: '#222222',
    wordBreak: 'break-word'
  },
  interactionsMobileStatusContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 5,
    paddingTop: 4,
  },
  waStatusText: {
    color: '#aaaaaa',
    fontWeight: 'bold',
    fontSize: 12
  },
  mediaBubble: {
    width: 220,
    aspectRatio: '16 / 9',
    borderRadius: 6,
    backgroundColor: '#e4e6eb',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    marginBottom: 6,
    marginTop: 5,
    fontWeight: 500,
    gap: 5
  },
  mediaPreview: {
    width: '100%',
    height: 'auto',
    maxHeight: '50vh',
    objectFit: 'contain',
    display: 'block'
  },
  customModalDescriptionStyles: {
    color: 'green'
  },
})